<template>
  <div class="container landing-casino">
    <div class="casino-top-header">
        <div>
          <p>{{ $store.getters['getClientMeta'].name }}</p>
          <h3 class="line-title">Canlı Casino</h3>
        </div>
    </div>
    <Providers/>
  </div>
</template>

<script>
  import Providers from './Providers'
  export default{
    components:{
      Providers
    }
  }
</script>
